"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const wrappers_1 = require("quasar/wrappers");
const vue_router_1 = require("vue-router");
const routes_1 = __importDefault(require("./routes"));
/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */
exports.default = wrappers_1.route(function ( /* { store, ssrContext } */) {
    const createHistory = process.env.SERVER
        ? vue_router_1.createMemoryHistory
        : process.env.VUE_ROUTER_MODE === 'history'
            ? vue_router_1.createWebHistory
            : vue_router_1.createWebHashHistory;
    const Router = vue_router_1.createRouter({
        scrollBehavior: () => ({ left: 0, top: 0 }),
        routes: routes_1.default,
        // Leave this as is and make changes in quasar.conf.js instead!
        // quasar.conf.js -> build -> vueRouterMode
        // quasar.conf.js -> build -> publicPath
        history: createHistory(process.env.MODE === 'ssr' ? void 0 : process.env.VUE_ROUTER_BASE),
    });
    return Router;
});
